<template>
  <div class="container-wrapper">
    <div class="unconnected" v-if="!needRefresh">
      <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-alert-circle"></use>
      </svg>
      Disconnected
    </div>
    <img class="i-charts-alarm" slot="reference" :src="marker_alarm" v-if="onAlarm" />
    <div class="container" ref="container">

    </div>
  </div>
</template>

<script>
import Highcharts from 'highcharts'
import miment from 'miment'
import { ERR_DATA, MAX_POINTS, ERR_DATA_REPLACE } from './config'
const PROP = 'Temperature'
const DIS_CONNECTED = 'D'
const CONNECTED = 'C'
const colorOptions = ['#4CAF50', '#F44336']
const ALLOW_OVERLAP = true

export default {
  props: {
    datas: {
      type: Object,
      default: () => ({})
    },
    itemHistorys: {
      type: Array,
      default: () => ({})
    },
    onAlarm: {
      type: Boolean,
      default: false
    },
    run: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    needRefresh() {
      return this.datas.Status == 2 || this.datas.Status == 3
    }
  },
  watch: {
    datas(newVal, oldVal) {
      return
      // console.log('变化', !this.needRefresh, newVal.Status)
      // 如果未连接，则不需要刷新
      if (!this.needRefresh) {
        return
      }

      if (!this.chart) {
        return
      }

      if (!this.run) {
        return
      }

      // 增加一个点，刷新一下图表信息
      const series = this.chart.series[0]
      const series1 = this.chart.series[1]

      const x = miment(newVal.RcvTime).stamp()
      const y = newVal[PROP]
      const pop = series.data.length > MAX_POINTS
      //console.log(y != ERR_DATA, '增加点', [x,y])
      //series.addPoint([x, y], true, pop);
      console.log('增加数据点', newVal.RcvTime + '- -' + newVal[PROP],oldVal.RcvTime + '- -' + oldVal[PROP], this.itemHistorys)

      // let preItem
      // if (series.data.length > 0) {
      //   preItem = series.data[series1.data.length - 1]
      // } else if (this.itemHistorys.length > 0 && this.itemHistorys[this.itemHistorys.length - 1][PROP] == ERR_DATA) {
      //   preItem = {
      //     y: null
      //   }
      // }

      // console.log('前一个项目', preItem, preItem ? preItem.y : '--', series.data)

      if (y != ERR_DATA) {
        let dataLabels = null
        if (this.m_oldVal && (this.m_oldVal[PROP] == ERR_DATA)) {
          dataLabels = {
            enabled: true,
            color: colorOptions[0],
            format: CONNECTED
          }

          series1.addPoint({x, y: ERR_DATA_REPLACE, dataLabels, extData: newVal.DeviceName}, true, pop);
        } else {
          series1.addPoint([x, null], true, pop);
        }

        series.addPoint({x, y}, true, pop);
        //console.log(series1)
      } else {
        let dataLabels = null
        if (this.m_oldVal && (this.m_oldVal[PROP] == ERR_DATA)) {
          dataLabels = {
            enabled: true,
            color: colorOptions[1],
            format: DIS_CONNECTED
          }
          // 把最后一个点增加错误
          if (series1.data.length > 0) {
            let all = series1.data.slice().map(i => {
              return { x: i.x, y: i.y, dataLabels: i.dataLabels || {} }
            })
            let last = all[all.length - 1]
            last.dataLabels = dataLabels
            last.y = ERR_DATA_REPLACE
            last.extData = newVal.DeviceName
            all.splice(all - 1, 1, last)
            series1.setData(all)
          }
        }

        series.addPoint([x,null], true, pop);
        series1.addPoint({x, y: ERR_DATA_REPLACE, extData: newVal.DeviceName}, true, pop);
      }


      this.m_oldVal = newVal
      //console.log(series1)
    }
  },
  methods: {
    init() {
      var _this = this

      Highcharts.setOptions({
          global: {
              useUTC: false
          }
      });
      function activeLastPointToolip(chart) {
          if (!chart) {
            return
          }
          // console.log('chart.series[0].points', chart.series,chart.series[0])
          var points = chart.series[0].points;
          points.length && chart.tooltip.refresh(points[points.length -1]);
      }
      // eslint-disable-next-line
      var chart = Highcharts.chart(this.$refs.container, {
          chart: {
              type: 'spline',
              marginRight: 10,
              events: {
                  load: function () {

                      // 保存图表变量
                      _this.chart = this;

                      // 如果未连接，则不需要刷新
                      if (!_this.needRefresh) {
                        return
                      }

                      // 显示第一个点
                      // var series = this.series[0],
                      let chart = this;
                      activeLastPointToolip(chart);

                      // setInterval(function () {
                      //     var x = (new Date()).getTime(),  // 当前时间
                      //         y = _this.datas.Temperature; // 温度
                      //     const pop = series.data.length > MAX_POINTS
                      //     y != ERR_DATA && series.addPoint([x, y], true, pop);
                      //     activeLastPointToolip(chart);
                      // }, 3000);
                  }
              }
          },
          title: {
              //text: `Temperature °C (Sensor ID：${this.datas.ModuleSN})`
              text: `Temperature (°C)`
          },
          xAxis: {
              type: 'datetime',
              tickPixelInterval: 150
          },
          yAxis: {
              // tickPositions: [16, 20, 24, 28, 32],
              title: {
                  text: null
              }
          },
          // plotOptions: {
          //     series: {
          //       dataLabels: {
          //         enabled: true,
          //         borderRadius: 2,
          //         color: _this.typeText(this) == CONNECTED ? colorOptions[0] : colorOptions[1],
          //         formatter: function () {
          //           return _this.typeText(this)
          //         }
          //       }
          //     }
          // },
          tooltip: {
              formatter: function () {
                const isError = _this.chart.series.indexOf(this.series)
                //console.log(this)
                if (isError) {
                  let name
                  let title
                  let style
                  try{
                    name = this.point.options.extData
                    title = _this.hasLabel(this.point)
                      ? (this.point.dataLabels.format == DIS_CONNECTED ? 'Disconnected' : 'Connected')
                      : 'Disconnected'
                    style = _this.hasLabel(this.point)
                      ? (this.point.dataLabels.format == DIS_CONNECTED ? 'style="color:red;"' : 'style="color:green;"')
                      : 'style="color:red;"'
                  }
                  catch(e) {
                    name = 'error'
                    title = 'Disconnected'
                    style = 'style="color:red;"'
                  }

                  return `<b ${style}>${title}</b><br/>`
                    + Highcharts.dateFormat('%Y-%m-%d %H:%M:%S', this.x) + '<br/>' + name
                } else {
                  return '<b>' + this.series.name + '</b><br/>' +
                    Highcharts.dateFormat('%Y-%m-%d %H:%M:%S', this.x) + '<br/>' +
                    Highcharts.numberFormat(this.y, 1) + '°C'
                }
              }
          },
          legend: {
              enabled: false
          },
          series: [{
              name: 'Temperature',
              data: _this.getData()[0],
              marker: {
                enabled: false
              }
          }, {
            name: 'Temperature',
            data: _this.getData()[1],
            dataLabels: { allowOverlap: ALLOW_OVERLAP },
            color: '#9E9E9E',
            type: 'area',
            marker: {
              enabled: false
            }
          }],
          credits: {
            enabled: false
          }
      })
      //console.log(chart, chart.series[0])
      // this.chart = chart
    },
    getData() {
      // 生成随机值
      let data = []
      let errData = []
      let time = (new Date()).getTime()
      let i

      if (!this.needRefresh) {
        return [[], []]
      }

      if (this.itemHistorys.length > 0) {
        let preIndex = -1
        let nextIndex = 1
        let beforePre = -2
        for (let i = 0; i < this.itemHistorys.length; i += 1, preIndex++, nextIndex++, beforePre++) {
          let options = this.typeText(this.itemHistorys[i],
            this.itemHistorys[preIndex < 0 ? 0 : preIndex],
            this.itemHistorys[nextIndex > this.itemHistorys.length - 1 ? this.itemHistorys.length - 1 : nextIndex])

          // let beforePreItem = beforePre < 0 ? null : this.itemHistorys[beforePre]
          // let preItem = preIndex < 0 ? null : this.itemHistorys[preIndex]
          // let nextItem = nextIndex > this.itemHistorys.length - 1 ? null : this.itemHistorys[nextIndex]

          if (this.itemHistorys[i][PROP] != ERR_DATA) {

            // // 前一条正常，前两条错误,下一条正常
            // if (beforePreItem && preItem && nextItem
            //   && (preItem[PROP] != ERR_DATA) && (beforePre[PROP] == ERR_DATA) && (nextItem[PROP] == ERR_DATA)) {
            //   console.log('insert a addition data point.', beforePreItem[PROP], preItem[PROP], this.itemHistorys[i][PROP], nextItem[PROP])
            //   errData.push({
            //     x: miment(this.itemHistorys[i].RcvTime).stamp() - 1000,
            //     y: null
            //   })
            //   data.push({
            //     x: miment(this.itemHistorys[i].RcvTime).stamp() - 1000,  // x轴
            //     y: this.itemHistorys[i][PROP],  // y轴
            //   })
            // }

            // // 前后都是异常,不显示标签
            // if (preItem && nextItem && (preItem[PROP] == ERR_DATA) && (nextItem[PROP] == ERR_DATA)) {
            //   options = {}
            // }

            // // 前后都是正常,不显示标签
            // if (preItem && nextItem && (preItem[PROP] != ERR_DATA) && (nextItem[PROP] != ERR_DATA)) {
            //   options = {}
            // }

            // 正确数据
            data.push({
                x: miment(this.itemHistorys[i].RcvTime).stamp(),  // x轴
                y: this.itemHistorys[i][PROP],  // y轴
                //dataLabels: options,
            })

            // 如果下一个点或者上一个点为错误
            if (options.format == DIS_CONNECTED || options.format == CONNECTED) {
              errData.push({
                x: miment(this.itemHistorys[i].RcvTime).stamp(),
                y: ERR_DATA_REPLACE,
                dataLabels: options,
                extData: this.itemHistorys[i].DeviceName
              })
            } else {
              errData.push({
                x: miment(this.itemHistorys[i].RcvTime).stamp(),
                y: null
              })
            }

          } else {

            // 错误数据
            data.push({
                x: miment(this.itemHistorys[i].RcvTime).stamp(),  // x轴
                y: null  // y轴
            })
            errData.push({
                x: miment(this.itemHistorys[i].RcvTime).stamp(),  // x轴
                y: ERR_DATA_REPLACE,  // y轴
                dataLabels: options,
                extData: this.itemHistorys[i].DeviceName
            })
          }

        }
      } else {
        for (i = -19; i <= 0; i += 1) {
          if (this.datas[PROP] != ERR_DATA) {
            data.push({
              x: time + i * 3000,  // x轴
              y: this.datas[PROP]  // y轴
            });
            errData.push({
              x: time + i * 3000,  // x轴
              y: null  // y轴
            })
          } else {
            data.push({
              x: time + i * 3000,  // x轴
              y: null  // y轴
            })
            errData.push({
              x: time + i * 3000,  // x轴
              y: ERR_DATA_REPLACE  // y轴
            });
          }
        }
      }

      if (this.itemHistorys.length > 0) {
        this.m_oldVal = this.itemHistorys[this.itemHistorys.length -1]
      }
      //console.log(errData)
      return [data, errData];
    },
    hasLabel(point) {
      return point.dataLabels && point.dataLabels.format
    },
    reflow() {
      this.chart.reflow()
    },
    redraw() {
      if (this.chart) {
        const current = this.getData()
        this.chart.series[0].setData(current[0])
        this.chart.series[1].setData(current[1])
      }
    },
    typeText(current, pre, next) {
      if (current == pre) {
        // 第一条数据时，不显示标签
        return {}
      }
      if (current == next && pre[PROP] != ERR_DATA) {
        // 最后一条数据
        return {}
      }
      if (current[PROP] != ERR_DATA && next[PROP] == ERR_DATA) {
        return {
          enabled: true,
          color: colorOptions[1],
          format: DIS_CONNECTED
          //y: -40
        }
      }
      if (current[PROP] != ERR_DATA && pre[PROP] == ERR_DATA) {
        return {
          enabled: true,
          color: colorOptions[0],
          format: CONNECTED,
          //y: -40,
          shape: 'callout',
          className: 'label-tip'
        }
      }
      return {}
    },
  },
  mounted() {
    try{
      this.init()
    }
    catch(ex){
      console.error(ex)
    }
  },
  created() {
    this.marker_alarm = require('../../../assets/icon/alarm.gif')
  }
}
</script>

<style lang="scss" scoped>
.container-wrapper {
  position: relative;
  .i-charts-alarm {
    position: absolute;
    top: 0px;
    left: 10px;
    width: 40px;
    height: 40px;
    z-index: 100;
  }
  .container {
  height: 200px;
  }
  .unconnected {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(96,125,139,.4);
    text-align: center;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #FFF;
  }
  & /deep/ .label-tip {
    // fill: '#4CAF50';
    //visibility: visible !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/home/charts/chart-temperature-h.vue